<template>
    <div class="mub-wrapper" :class="{'w-100 h-100': !blockItem && fullMub}" :data-mub="mubData">
        <slot />
    </div>
</template>

<script>
import HomeBlock from '@/models/home-block';
import HomeProduct from '@/models/Home/home-product';
import { BlockItem } from '@/models/Blocks/Itens/block-item';
//import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';

export default {
    components:{
    },
    props:{
        // full block object (pre black rabbit version)
        block:{
            type: HomeBlock
        },
        // product belonging to block (pre black rabbit version)
        blockProduct:{
            type: HomeProduct
        },
        // combo belonging to block (sufixed with "data" because it's a simple object)
        blockComboData:{
            type: Object
        },
        // Black rabbit blocks
        blockItem:{
            type: BlockItem
        },
        // use with raw data (usefull when data is returned formatted from backend)
        rawData:{
            type: Object
        },
        // basic data: type, name and ta (target)
        type: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        ta: {
            type: String,
            default: null,
        },
        meta: {
            type: Object,
            default: null,
        },
        fullMub: { // w-100 && h100
            type: Boolean,
            default: true,
        }
    },
    data(){
        return{
        }
    },
    // mounted() {
    //     //console.log('this.$refs', this.$refs);
    // },
    // updated(){
    // },
    // created() {
    // },
    // destroyed() {
    // },
    watch: {
        blockHasData(newValue){
            // use next thick because right now, DOM element does not have MUB attribute rendered
            this.$nextTick(function() {
                if(window && window.mub){
                    // add MUB monitoring to element
                    window.mub.addObserver(this.$el, false, null);
                }
            });
        }
    },
    computed: {
        mubData(){
            if(this.rawData){
                return JSON.stringify(this.rawData);
            }
            
            if(this.blockHasData){
                //console.log('this.block.mubData ', this.block.mubData);
                if(this.block){
                    return this.block.mubData;
                }
                if(this.blockProduct){
                    return this.blockProduct.mubData;
                }
                if(this.blockItem){
                    //console.log('this.blockItem.mubData', this.blockItem.mubData);
                    return this.blockItem.mubData;
                }
                //return this.block ? this.block.mubData : this.blockProduct.mubData;
            }
            if(this.blockComboData && this.blockComboData.mub){
                return JSON.stringify(this.blockComboData.mub);
            }

            if(this.type && this.name){
                //console.log('mub data', this.type, this.name)
                return JSON.stringify({
                    t: this.type,
                    b: this.name,
                    ta: this.ta,
                    m: this.meta
                });
            }

            return null;
        },
        blockHasData(){
            if(this.block && this.block.items){
                return true;
            }
            if(this.blockProduct){
                if(this.blockProduct.type == 'product' && this.blockProduct.mubData) return true;
            }
            if(this.blockItem && !this.blockItem.skeleton){
                //console.log('MUB component: has this.blockItem', this.blockItem);
                return true;
            }

            return false;
        }
    },
    // methods: {
    // }
}
</script>
